module.exports = __webpack_public_path__ + "assets/aeedde19ce9005d85ac5b1b9cfee73b3.mp3";